import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { GetSignedData } from "../../../../services/collegeRequests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faTimes } from "@fortawesome/free-solid-svg-icons";

const SignedData = () => {
  const { id } = useParams();
  const [signedData, setSignedData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expandedSections, setExpandedSections] = useState({});
  const [popupContent, setPopupContent] = useState(null);

  // API Call
  useEffect(() => {
    const fetchSignedData = async () => {
      try {
        setLoading(true);
        const response = await GetSignedData(id);
        setSignedData(response.data.result);

        // Initialize all sections to be collapsed
        const initialExpandedState = {
          terms: false,
          agreement: false,
          tcs: false,
          tds: false,
        };
        setExpandedSections(initialExpandedState);
      } catch (error) {
        console.error("Error fetching signed data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchSignedData();
    }
  }, [id]);

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const openPopup = (content) => {
    setPopupContent(content);
  };

  const closePopup = () => {
    setPopupContent(null);
  };

  // Helper function to get status
  const getStatus = (value) => {
    return value === "1" ? "Signed" : "Not Signed";
  };

  // Helper to check if data exists and is not "undefined" string
  const hasValidData = (data) => {
    return data && data !== "undefined" && data !== null;
  };

  // Function to render document section
  const renderDocumentSection = (sectionKey, title, dataKey, data) => {
    if (!hasValidData(data)) return null;

    return (
      <div className="sign-dtl-section">
        <h3 className="sign-dtl-section-title">{title}</h3>
        <div className="sign-dtl-document-card">
          <div
            className="sign-dtl-document-header"
            onClick={() => toggleSection(sectionKey)}
          >
            <h4 className="sign-dtl-document-title">{title} Agreement</h4>
            <FontAwesomeIcon
              icon={faChevronDown}
              className={`sign-dtl-accordion-icon ${
                expandedSections[sectionKey] ? "open" : ""
              }`}
            />
          </div>
          {expandedSections[sectionKey] && (
            <div className="sign-dtl-document-body">
              <div dangerouslySetInnerHTML={{ __html: data }} />
            </div>
          )}
        </div>
      </div>
    );
  };

  if (loading) {
    return <div className="sign-dtl-loading">Loading signed data...</div>;
  }

  if (!signedData) {
    return <div className="sign-dtl-loading">No signed data available</div>;
  }

  return (
    <div className="sign-dtl-container">
      <div className="sign-dtl-header">
        <h1>Signed Agreements</h1>
      </div>

      {/* Status Overview Cards */}
      <div className="sign-dtl-info-grid">
        <div className="sign-dtl-info-card">
          <h3 className="sign-dtl-info-title">Terms & Conditions</h3>
          <span
            className={`sign-dtl-status ${getStatus(
              signedData?.terms_conditions
            ).toLowerCase()}`}
          >
            {getStatus(signedData?.terms_conditions)}
          </span>
        </div>

        <div className="sign-dtl-info-card">
          <h3 className="sign-dtl-info-title">Agreement</h3>
          <span
            className={`sign-dtl-status ${getStatus(
              signedData?.aggrement
            ).toLowerCase()}`}
          >
            {getStatus(signedData?.aggrement)}
          </span>
        </div>

        <div className="sign-dtl-info-card">
          <h3 className="sign-dtl-info-title">TCS</h3>
          <span
            className={`sign-dtl-status ${getStatus(
              signedData?.tcs
            ).toLowerCase()}`}
          >
            {getStatus(signedData?.tcs)}
          </span>
        </div>

        <div className="sign-dtl-info-card">
          <h3 className="sign-dtl-info-title">TDS</h3>
          <span
            className={`sign-dtl-status ${getStatus(
              signedData?.tds
            ).toLowerCase()}`}
          >
            {getStatus(signedData?.tds)}
          </span>
        </div>
      </div>

      {/* Signature Information */}
      {signedData?.aggrement_sign && (
        <div className="sign-dtl-section">
          <h3 className="sign-dtl-section-title">Signature Information</h3>
          <div className="sign-dtl-info-card">
            <h3 className="sign-dtl-info-title">Agreement Signature</h3>
            <p>{signedData.aggrement_sign}</p>
          </div>
        </div>
      )}

      {/* Document Sections */}
      {renderDocumentSection(
        "terms",
        "Terms & Conditions",
        "terms_conditions_data",
        signedData?.terms_conditions_data
      )}

      {renderDocumentSection(
        "agreement",
        "Agreement",
        "aggrement_data",
        signedData?.aggrement_data
      )}

      {renderDocumentSection("tcs", "TCS", "tcs_data", signedData?.tcs_data)}

      {renderDocumentSection("tds", "TDS", "tds_data", signedData?.tds_data)}

      {/* Popup for fullscreen content */}
      {popupContent && (
        <div className="sign-dtl-popup-overlay">
          <div className="sign-dtl-popup-content">
            <button className="sign-dtl-popup-close" onClick={closePopup}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <div dangerouslySetInnerHTML={{ __html: popupContent }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default SignedData;
